import React from "react"
import { Typography, withStyles } from "@material-ui/core";
import styles from "./styles"
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { translate } from "react-i18next";
import { compose } from "redux";

const RouteContact = ({ t, classes }) => (
    <div className={classes.root}>
        <Header activePage={"contact"} />
        <div className={classes.elements}>
            <div className={classes.text}>
                <div className={classes.textField}>
                    <div className={classes.textBox}>
                        <Typography className={classes.title}>{t("main:contact")}</Typography>
                        <Typography dangerouslySetInnerHTML={{ __html: t("main:contact_information") }} />
                    </div>
                </div>
                <div className={classes.byText}>
                    <Typography className={classes.textSide} align={"center"}>{t("main:contact_byText")}</Typography>
                </div>
            </div>
            <div className={classes.footer}>
                <Footer />
            </div>
        </div>
    </div>
);

export default compose(
    translate(),
    withStyles(styles)
)(RouteContact)